import React from 'react';
import { Segment } from 'semantic-ui-react';
import { withRouter } from 'react-router';

const BrandSizeNotDefined = ({history, match, ...restProps}) => (
  <Segment color='red'>
    <h5>A brand size should be selected first
    </h5>
    <div className='button-block'>
      <button onClick={() => {
        let id = match.params.id;
        history.push(`/brandLanding/${id}`);
      }}>
        Back To Brand Page
      </button>
      <button onClick={() => {
        let id = match.params.id;
        history.push(`/brandGeneral/${id}`);
      }}>
        Back to Brand General
      </button>
    </div>
  </Segment>
);

export default withRouter(BrandSizeNotDefined);



// WEBPACK FOOTER //
// ./src/components/Sentences/BrandSizeNotDefined.js